import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { getLocationBlocks } from "../../../../../core/api/services/block.service";
import TableSort from "../../../../../shared/helpers/table-sort";
import BlockTableComponent from "./block-table.component";

const BlockComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [blockSearchValue, setBlockSearchValue] = useState("");
  const pageSize = 10;
  const [SortBy, setSortBy] = useState<any>("BlockCode");
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Block Code",
      label: "blockCode",
      isSorted: true,
      // width: "8rem"
    },
    {
      title: "Block Name",
      label: "blockName",
      // width: "8rem"
    },
    {
      title: "Site",
      label: "siteName",
      // width: "13rem"
    },
    // {
    //   title: "No of Floor",
    //   label: "noOfFloor",
    //   // width: "10rem"
    // },
    {
      title: "Street",
      label: "street",
      // width: "13rem",
    },
  ]);

  const {
    data: locationBlocks,
    isLoading: isLoadingLocationBlocks,
    refetch,
  } = useQuery({
    queryKey: [
      "getLocationBlocks",
      PageNumber,
      SortBy,
      SortDirection,
      blockSearchValue,
    ],
    queryFn: ({ signal }) =>
      getLocationBlocks(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        blockSearchValue,
        signal
      ),
  });

  const onRefetchData = () => {
    if (locationBlocks?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setBlockSearchValue(searchVal);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <BlockTableComponent
        columns={columns}
        data={locationBlocks?.data}
        totalNumberOfRecords={locationBlocks?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingLocationBlocks}
        onSearch={handleSearch}
      />
    </div>
  );
};

export default BlockComponent;
